export default __webpack_public_path__ + "static/media/welcomeLogo.1650c199.svg";